<template>
  <div class="table-responsive mb40">
    <table class="table table-bordered bg-white tbl_order01 top01">
      <thead class="bg-tbl-head">
        <tr>
          <th>会社名</th>
          <th>支店・工場名</th>
          <th>住所</th>
          <th>TEL</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <delivery-history-top5-row
          v-for="deliveryData in sortedDeliveryList"
          :key="deliveryData.row_no"
          :selected-cd="selectedCd"
          :deliveryData="deliveryData"
          @select="selectDeliveryDataHandler"
        ></delivery-history-top5-row>
      </tbody>
    </table>
  </div>
</template>

<script>
// Components
import DeliveryHistoryTop5Row from "./Row.vue";

export default {
  components: {
    DeliveryHistoryTop5Row
  },
  props: {
    selectedCd: { type: String, required: false },
    deliveryDataList: { type: Array, required: true }
  },
  computed: {
    sortedDeliveryList() {
      if (!this.deliveryDataList) {
        return [];
      }
      let best5Date;

      best5Date = Array.from(this.deliveryDataList);
      best5Date.sort((a, b) => {
        return parseInt(a.dlranking_no, 10) - parseInt(b.dlranking_no, 10);
      });

      best5Date = best5Date.slice(0, 5);

      let is_added = false;
      if (this.selectedCd) {
        if (!best5Date.some(row => row.delivery_cd === this.selectedCd)) {
          const targetDelivery = this.deliveryDataList.find(
            el => el.delivery_cd === this.selectedCd
          );

          if (targetDelivery) {
            best5Date.push(targetDelivery);
            is_added = true;
          }
        }
      }

      return best5Date.map(row => {
        row.is_added = false;
        if (row.delivery_cd === this.selectedCd && is_added) {
          row.is_added = true;
        }
        return row;
      });
    }
  },
  methods: {
    selectDeliveryDataHandler(deliveryData) {
      this.$emit("select", deliveryData);
    }
  }
};
</script>
